//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Builder.js";
let d=[[],[[["num_inputs"],"GetInputs",{R_:{inputs:"MBD.WebRuleInstanceInput[]"}},0,0],[[],"GetRuleName",{R_:{ruleName:''}},0,0],[["num_inputs"],"GetRuleAlerts",{R_:{alerts:""}},0,0],[["isValidRule","numInvalidNodeName"],"IsValidRule",{R_:{invalidNodeName:""}},0,0],[["numDetails","bodySelection","componentSelection","inputNodeName","inputNodeType"],"GetInputDetails",{},0,0]],[]];
SPLM.MBD.WebRuleInstanceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.WebRuleInstanceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;